import { render, staticRenderFns } from "./ShopProductDetailPage.vue?vue&type=template&id=f672ae72&"
import script from "./ShopProductDetailPage.vue?vue&type=script&lang=js&"
export * from "./ShopProductDetailPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports